import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { childrenComponent2Object } from 'function/convert';
import { getLoginInform } from 'function/login';
import useRoute from 'hooks/useRoute';
import { RETURN_YN } from 'types/type';
import isEmpty from 'utils/isEmpty';
import clean from 'utils/array/clean';

/**
 * 내용
 */
const Content = ({ children, className }) => {
  /* variable */
  const { title, headerButton, body, footerButton } =
    childrenComponent2Object(children);
  const { haccpYn } = getLoginInform();

  /* hook */
  const { navi } = useRoute();

  /* view */
  return (
    <Card className={className.root}>
      <Card.Header>
        <Row className="align-items-center g-2">
          <Col>
            <h5 className="mb-0">
              {/* TODO: SFSH 내비 공통화 */}
              {haccpYn === RETURN_YN.Y ? (
                title
              ) : (
                <>
                  {navi}
                  {!isEmpty(clean(navi?.props?.children)) &&
                    !isEmpty(title?.props?.children) &&
                    ' > '}
                  {title}
                </>
              )}
            </h5>
          </Col>
          {!isEmpty(headerButton?.props?.children) && (
            <Col xs="auto" className={className.headerButton}>
              {headerButton}
            </Col>
          )}
        </Row>
      </Card.Header>
      <Card.Body className={className.body}>{body}</Card.Body>
      {!isEmpty(footerButton?.props?.children) && (
        <Card.Footer className="d-flex align-items-center">
          {footerButton}
        </Card.Footer>
      )}
    </Card>
  );
};

Content.propTypes = {
  // 클래스 이름
  className: PropTypes.shape({
    root: PropTypes.string,
    headerButton: PropTypes.string,
    body: PropTypes.string
  })
};
Content.defaultProps = { className: {} };

export default Content;
